import React, { FC } from 'react';
import VidupuLogo from '../assets/logos/Viduppu.png';
interface ILogoProps {
	width?: number;
	height?: number;
}
const Logo: FC<ILogoProps> = ({ width = 2155, height = 854 }) => {
	return (
		<img
			src={VidupuLogo}
			alt='logo'
			width={height !== 854 && !!height ? height * (2155 / 754) : width}
			height={width !== 2155 && !!width ? width * (854 / 2055) : height}
		/>
	);
};

export default Logo;
